/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  EmceeSheetContestantDTO,
  TabulatorLoginRequest,
  TabulatorLoginResponse,
  TabulatorReadOnlyDashboardDTO,
  UpdateTabulatorEventStatusRequest,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class TabulatorPortal<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags TabulatorPortal
   * @name LoginCreate
   * @request POST:/TabulatorPortal/login
   */
  loginCreate = (data: TabulatorLoginRequest, params: RequestParams = {}) =>
    this.request<TabulatorLoginResponse, any>({
      path: `/TabulatorPortal/login`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags TabulatorPortal
   * @name ReadonlyDashboardDetail
   * @request GET:/TabulatorPortal/readonly/dashboard/{pageantId}
   */
  readonlyDashboardDetail = (pageantId: number, params: RequestParams = {}) =>
    this.request<TabulatorReadOnlyDashboardDTO, any>({
      path: `/TabulatorPortal/readonly/dashboard/${pageantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags TabulatorPortal
   * @name GetEmceeSheets
   * @request GET:/TabulatorPortal/GetEmceeSheets/Pageant:{pageantId}
   */
  getEmceeSheets = (
    pageantId: number,
    query?: {
      /** @format int32 */
      divisionId?: number;
      /** @format int32 */
      ageGroupId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<EmceeSheetContestantDTO[], any>({
      path: `/TabulatorPortal/GetEmceeSheets/Pageant:${pageantId}`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags TabulatorPortal
   * @name GetResultsPdf
   * @request GET:/TabulatorPortal/ResultsPdf/Pageant:{pageantId}
   */
  getResultsPdf = (pageantId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/TabulatorPortal/ResultsPdf/Pageant:${pageantId}`,
      method: 'GET',
      ...params,
    });
  /**
   * No description
   *
   * @tags TabulatorPortal
   * @name StatusUpdate
   * @request PUT:/TabulatorPortal/status/{pageantId}
   */
  statusUpdate = (pageantId: number, data: UpdateTabulatorEventStatusRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/TabulatorPortal/status/${pageantId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
